import {Grid, Typography} from "@material-ui/core";
import React from "react";
import { connect } from 'react-redux';
import { compose } from 'redux';
import {withStyles} from "@material-ui/core/styles";
import {Constants} from "../../../utilities/constants";
import { addCommaSeparatorToNumber } from '../../../utilities/format';
import {LoadingOverlayWrapper} from "../../layout";

const ActiveWorkflow = ({
  classes, activeWorkflowTasks, terminatedTasks, closedTasks,
  activeWorkflowIsLoading, completedTasksIsLoading,
}) => {
  const cellClassName = `${classes.gridRow} ${classes.numberFormat}`;
  const totalResultClassName = `${cellClassName} ${classes.totalRow}`;
  const columnHeaderClassName = `${classes.gridLabel} ${classes.gridLabelFormat}`;

  function createRows(activeWorkflowTasks) {
    const rows = [];
    [
      {status: null, label: 'Incomplete'},
      {status: Constants.UnderwriteStatus.AUTOPRICED, label: 'Autopriced'},
      {status: Constants.UnderwriteStatus.PENDING, label: 'Pending'},
      {status: Constants.UnderwriteStatus.SAVEDPRICING, label: 'Saved Pricing'},
      {status: Constants.UnderwriteStatus.SAVEDNOBID, label: 'Saved No Bid'},
      {status: Constants.UnderwriteStatus.SUBMISSIONPENDING, label: 'Submission Pending'},
      {status: Constants.UnderwriteStatus.SUBMISSIONFAILED, label: 'Submission Failed'},
      {status: Constants.UnderwriteStatus.SUBMITTEDPRICING, label: 'Submitted Pricing'},
      {status: Constants.UnderwriteStatus.SUBMITTEDNOBID, label: 'Submitted No Bid'}
    ]
    .forEach((underwriteParams) => {
        rows.push(
          <Grid
            key={underwriteParams.label}
            item
            xs={2}
            className={`${classes.gridLabel} ${classes.gridRow}`}>
              {underwriteParams.label}
          </Grid>);

      [
        Constants.OpportunityStatus.PRESCREEN,
        Constants.OpportunityStatus.INITIAL,
        Constants.OpportunityStatus.COUNTER,
        Constants.OpportunityStatus.DUEDILIGENCE,
      ].forEach(opportunityStatus => {
        const count = activeWorkflowTasks
          .filter(f => f.opportunityStatus === opportunityStatus && f.underwriteStatus === underwriteParams.status)
          .reduce((accumulator, currentValue) => accumulator + currentValue.opportunitiesCount, 0);
        rows.push(
          <Grid
            key={`${count} ${underwriteParams.label} ${opportunityStatus}`}
            item
            xs={2}
            className={cellClassName}>
            {addCommaSeparatorToNumber(count)}
          </Grid>
        );
      });

      let totalRowCount = 0;

      activeWorkflowTasks
        .filter(f => f.underwriteStatus === underwriteParams.status)
        .forEach(element => { totalRowCount += element.opportunitiesCount });

      rows.push(
        <Grid
          key={`${totalRowCount} ${underwriteParams.label}`}
          item
          xs={2}
          className={`${totalResultClassName}`}>
          {addCommaSeparatorToNumber(totalRowCount)}
        </Grid>
      );
    });
    return rows;
  }

  function getTotal(columnStatus) {
    let total = 0;

    activeWorkflowTasks
      .filter(f => f.opportunityStatus === columnStatus)
      .forEach(item => { total += item.opportunitiesCount });

    return addCommaSeparatorToNumber(total);
  }

  function getAllAmount() {
    let totalAmount = 0;
    activeWorkflowTasks
      .forEach(item => { totalAmount += item.opportunitiesCount });

    return addCommaSeparatorToNumber(totalAmount);
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={10}>
        <LoadingOverlayWrapper
          active={activeWorkflowIsLoading}
          message={activeWorkflowIsLoading ? 'Fetching data...' : ''}
          className={classes.loadingOverlayWrapper}
          background={'rgba(242, 242, 242, 0.9)'}
        >

          <Grid container spacing={1} className={classes.gridRoundedContainer}>

            <Grid item xs={12}>
              <Typography variant="h6">Active Workflow</Typography>
            </Grid>

            <Grid item xs={2}></Grid>
            <Grid item xs={2} className={columnHeaderClassName}>Pre-Screen</Grid>
            <Grid item xs={2} className={columnHeaderClassName}>Initial</Grid>
            <Grid item xs={2} className={columnHeaderClassName}>Counter</Grid>
            <Grid item xs={2} className={columnHeaderClassName}>Due Diligence</Grid>
            <Grid item xs={2} className={columnHeaderClassName}>Total</Grid>

            {createRows(activeWorkflowTasks)}

            <Grid item xs={2} className={classes.gridRow} />
            <Grid
              item
              xs={2}
              className={`${totalResultClassName}`}
            >
              {getTotal(Constants.OpportunityStatus.PRESCREEN)}
            </Grid>
            <Grid
              item
              xs={2}
              className={`${totalResultClassName}`}
            >
              {getTotal(Constants.OpportunityStatus.INITIAL)}
            </Grid>
            <Grid
              item
              xs={2}
              className={`${totalResultClassName}`}
            >
              {getTotal(Constants.OpportunityStatus.COUNTER)}
            </Grid>
            <Grid
              item
              xs={2}
              className={`${totalResultClassName}`}>
              {getTotal(Constants.OpportunityStatus.DUEDILIGENCE)}
            </Grid>
            <Grid
              item
              xs={2}
              className={`${totalResultClassName}`}>
              {getAllAmount()}
            </Grid>
            <Grid item xs={12}></Grid>

          </Grid>

        </LoadingOverlayWrapper>
      </Grid>

      <Grid item xs={2} className={classes.wrap}>
        <LoadingOverlayWrapper
          active={completedTasksIsLoading}
          message={completedTasksIsLoading ? 'Fetching data...' : ''}
          className={`${classes.loadingOverlayWrapper} ${classes.overlayWrapper}`}
          background={'rgba(242, 242, 242, 0.9)'}
        >

          <Grid
            container
            spacing={1}
            className={`${classes.gridRoundedContainer} ${classes.terminatedClosedContainer}`}
          >
            <Grid item xs={12} className={classes.closedGridLabel}>Terminated (30 Days)</Grid>
            <Grid item xs={12} className={classes.closedGridLabel}>
              <Typography variant="h6">{terminatedTasks}</Typography>
            </Grid>
            <Grid item xs={12} className={classes.closedGridLabel}>Closed (30 Days)</Grid>
            <Grid item xs={12} className={classes.closedGridLabel}>
              <Typography variant="h6">{closedTasks}</Typography>
            </Grid>
          </Grid>

        </LoadingOverlayWrapper>
      </Grid>
    </Grid>
  );
}

const styles = ({
  wrap: {
    display: 'flex',
  },
  overlayWrapper: {
    width: '100%',
  },
  terminatedClosedContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  gridRoundedContainer: {
    border: '1px solid #000',
    borderRadius: '4px',
    height: "100%",
    paddingTop: 5,
    backgroundColor: "#fff",
    margin: 0,
  },
  gridLabel: {
    fontWeight: 600,
  },
  closedGridLabel: {
    fontWeight: 600,
    textAlign: "center",
  },
  gridRow: {
    borderTop: '1px solid black'
  },
  totalRow: {
    fontWeight: '700',
  },
  numberFormat: {
    textAlign: 'end',
    fontSize: 13,
    fontFamily: 'Roboto, RobotoFallback, Helvetica, Arial, sans-serif'
  },
  gridLabelFormat: {
    textAlign: 'end',
  }
});

const mapStateToProps = (state) => ({
  terminatedTasks: state.dashboardState.terminatedTasks,
  closedTasks: state.dashboardState.closedTasks,
  activeWorkflowIsLoading: state.dashboardState.activeWorkflowIsLoading,
  completedTasksIsLoading: state.dashboardState.completedTasksIsLoading,
});

const mapDispatchToProps = (dispatch) => ({
});

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(ActiveWorkflow);
